import { render, staticRenderFns } from "./swiperSmall.vue?vue&type=template&id=b668b1fa&scoped=true&"
import script from "./swiperSmall.vue?vue&type=script&lang=js&"
export * from "./swiperSmall.vue?vue&type=script&lang=js&"
import style0 from "./swiperSmall.vue?vue&type=style&index=0&id=b668b1fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b668b1fa",
  null
  
)

export default component.exports